import { useQueries, useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import query from './constants.api';

const useMultipleFetch = (multipleQueries) => {
    const fetchData = (props) => {
        return axiosInstance('GET', props.path, null, props.params, 'application/json', multipleQueries.baseUrl);
    };
    
    return useQueries(
        multipleQueries.map((element, index) => { return {queryKey: ['post', element.id], queryFn: () => fetchData(element)} })
    )
};

export default useMultipleFetch;